import Navbar from "../components/Navbar";
import HeroSection from "../components/HeroSection";
import TourSection from "../components/TourSection";
import Footer from "../components/Footer";
import WhoWeAreSection from "../components/WhoWeAreSection";
import GallerySection from "../components/GallerySection";

function Home() {
  return (
    <>
      <Navbar />
      <HeroSection />
            <WhoWeAreSection />

      <TourSection />
                  <GallerySection />

      <Footer />
    </>
  );
}

export default Home;